import { App, Plugin } from 'vue';

export const withInstall = <T>(comp: T): T & Plugin => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const c = comp as any;
  c.install = function (app: App) {
    app.component(c.name, comp);
  };

  return comp as T & Plugin;
};

// eslint-disable-next-line arrow-body-style
export const createComponent = <T>(comp: any, name: string): T & Plugin => {
  return withInstall(Object.assign({}, comp, { name }));
};

/**
 * 函数节流 - 随动画帧节流
 */
export const throttleWithFrame = function (fn: () => any) {
  let req = null;
  return function (...args) {
    if (!req) {
      req = window.requestAnimationFrame(() => {
        fn.apply(this, args);
        req = null;
      });
    }
  };
};
